export default "__VITE_ASSET__BP0Sos05__"